import { ApiEpBilling } from "@smp/api";
import { useQuery } from "react-query";

import { gscSendUserParams } from "@/utils";

const KEY = "ep.billing.current_plansubscription";

export const useEpBillingCurrentPlansubscription = () => {
  const {
    data: currentPlansubscription,
    isLoading: isCurrentPlansubscriptionLoading,
  } = useQuery([KEY], () => ApiEpBilling.CurrentPlansubscription.retrieve(), {
    onSuccess: (data) => {
      gscSendUserParams({
        plan_id: data.plan_id,
      });
    },
  });

  return { currentPlansubscription, isCurrentPlansubscriptionLoading };
};

useEpBillingCurrentPlansubscription.KEY = KEY;
